/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccesibilidadDto } from '../../models/accesibilidad-dto';

export interface AccesibilidadControllerActualizarAccesibilidad$Params {
      body: AccesibilidadDto
}

export function accesibilidadControllerActualizarAccesibilidad(http: HttpClient, rootUrl: string, params: AccesibilidadControllerActualizarAccesibilidad$Params, context?: HttpContext): Observable<StrictHttpResponse<AccesibilidadDto>> {
  const rb = new RequestBuilder(rootUrl, accesibilidadControllerActualizarAccesibilidad.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccesibilidadDto>;
    })
  );
}

accesibilidadControllerActualizarAccesibilidad.PATH = '/api/accesibilidad/actualizar-accesibilidad';
